<template>
  <van-popup v-model="visible" position="top" :overlay="false">
    <div class="head">
      <span class="title">更多功能</span>
      <img
        src="@/assets/groupRob/close-2.png"
        alt=""
        class="close"
        @click="close"
      />
    </div>
    <div class="actions">
      <div class="item" @click="toShare">
        <img src="@/assets/groupRob/share.png" alt="" class="share" />
        <span class="label">分享</span>
      </div>
      <div class="item" @click="toRule">
        <img src="@/assets/groupRob/rule.png" alt="" class="rule" />
        <span class="label">活动规则</span>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  model: {
    prop: "visible",
    event: "visibleChange",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      D: null,
    };
  },
  created() {
    this.$api
      .get("activity/index/panic/get-panic-config")
      .then((res) => (this.D = res));
  },
  methods: {
    close() {
      this.$emit("visibleChange", false);
    },
    toShare() {
      this.close();
      let paramAndroid = [
        this.D.share_title,
        this.D.share_subtitle,
        `${process.env.VUE_APP_BASE_URL}/grouprob/a?share=1`,
        this.D.share_image,
      ];
      let paramIos = [
        this.D.share_subtitle,
        this.D.share_title,
        `${process.env.VUE_APP_BASE_URL}/grouprob/a?share=1`,
        this.D.share_image,
      ];
      this.params(paramIos, JSON.stringify(paramAndroid), "toShare");
    },
    toRule() {
      this.close();
      this.$parent.popupVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
.van-popup {
  border-radius: 0 0 0.8rem 0.8rem;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.8);
  padding: var(--status-height) 1.2rem 0.9rem;

  .head {
    margin-top: 3rem;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    font-size: 1.8rem;

    .close {
      width: 1.6rem;
      height: 1.6rem;
    }
  }

  .actions {
    margin-top: 1rem;
    display: grid;
    grid-template-columns: repeat(4, 25%);

    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      height: 5rem;

      .share {
        width: 2.5rem;
        height: 2.5rem;
      }

      .rule {
        width: 2.2rem;
        height: 2.4rem;
      }

      .label {
        color: #fff;
        font-size: 1.3rem;
      }
    }
  }
}
</style>
